import { render } from "./MessageFilterItem.vue?vue&type=template&id=2bf3ff02&scoped=true"
import script from "./MessageFilterItem.vue?vue&type=script&lang=js"
export * from "./MessageFilterItem.vue?vue&type=script&lang=js"

import "./MessageFilterItem.vue?vue&type=style&index=0&id=2bf3ff02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf3ff02"]])

export default __exports__